import React, { PureComponent } from 'react';
import { Translate } from 'react-redux-i18n';

import StringUtil from '../../app/utils/string';

class ManufacturerImportErrors extends PureComponent {
  render() {
    const { errors = [] } = this.props;

    if (!errors.length) return null;

    return (
      <div className="items-errors">
        <hr />

        <h5><Translate value="dragAndDropManufacturerErrorTitle" /></h5>

        {errors.map(error => (
          <React.Fragment key={error.name}>
            <p>
              <Translate value="name" />
              {': '}
              <b>{error.name}</b>

              {' - '}
              <Translate value="line" />
              {' '}
              {error.line}
              {': '}

              {error.types.map((type, index) => (
                <React.Fragment>
                  <Translate value={`dragAndDropManufacturerError${StringUtil.capitalizeFirstLetter(type)}`} />
                  {index !== error.types.length - 1 ? ', ' : ''}
                </React.Fragment>
              ))}
            </p>
          </React.Fragment>
        ))}
      </div>
    );
  }
}

export default ManufacturerImportErrors;
